'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');
const designSystem = require('@zapier/design-system');
const React = require('react');
const Description_Description = require('../Description/Description.cjs.js');
const ErrorMessage_ErrorMessage = require('../ErrorMessage/ErrorMessage.cjs.js');
const Label_Label = require('../Label/Label.cjs.js');
const reactAria = require('react-aria');
const reactAriaComponents = require('react-aria-components');
const Typeahead_TypeaheadItem = require('./TypeaheadItem.cjs.js');
const Typeahead_TypeaheadRightSlot = require('./TypeaheadRightSlot.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const comboBox = "_combo-box_1twn7_1";
const inputWrapper = "_input-wrapper_1twn7_7";
const iconLeftWrapper = "_icon-left-wrapper_1twn7_11";
const input = "_input_1twn7_7";
const inputNoLeftIcon = "_input-no-left-icon_1twn7_64";
const popover = "_popover_1twn7_71";
const customWidth = "_custom-width_1twn7_77";
const listBox = "_list-box_1twn7_81";
const styles = {
	comboBox: comboBox,
	inputWrapper: inputWrapper,
	iconLeftWrapper: iconLeftWrapper,
	input: input,
	inputNoLeftIcon: inputNoLeftIcon,
	popover: popover,
	customWidth: customWidth,
	listBox: listBox
};

const TypeaheadRoot = React.forwardRef((_a, ref) => {
  var _b;
  var { children, className, classNamePopOver, defaultItems, defaultSelectedKey, defaultInputValue, errorMessage, helpText, iconLeft = "navSearch", inputValue, isBusy = false, isDisabled = false, isInvalid = false, items, label, menuWidth, menuTrigger, onSelectionChange, placeholder, iconRight = null, selectedKey, size = "large" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "classNamePopOver", "defaultItems", "defaultSelectedKey", "defaultInputValue", "errorMessage", "helpText", "iconLeft", "inputValue", "isBusy", "isDisabled", "isInvalid", "items", "label", "menuWidth", "menuTrigger", "onSelectionChange", "placeholder", "iconRight", "selectedKey", "size"]);
  const { contains } = reactAria.useFilter({ sensitivity: "base" });
  const defaultFilter = (_b = props.defaultFilter) !== null && _b !== void 0 ? _b : contains;
  return React__default.default.createElement(
    reactAriaComponents.ComboBox,
    Object.assign({}, props, { className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.comboBox, className], renderProps), defaultFilter, defaultItems, defaultSelectedKey, defaultInputValue, inputValue, isDisabled, isInvalid, items, menuTrigger, onSelectionChange, selectedKey, allowsEmptyCollection: true, "data-zds": true, shouldFocusWrap: true }),
    label && React__default.default.createElement(
      Label_Label.Label,
      { isCompact: size === "compact", isDisabled, isInvalid },
      isInvalid && React__default.default.createElement(designSystem.Icon, { color: "StatusErrorStronger", isBlock: true, name: "formXCircle", size: 18 }),
      label
    ),
    React__default.default.createElement(
      "div",
      { className: styles.inputWrapper, "data-zds": true },
      iconLeft && React__default.default.createElement("div", { className: styles.iconLeftWrapper, "data-size": size, "data-zds": true }, isBusy ? React__default.default.createElement(designSystem.Spinner, null) : React__default.default.createElement(designSystem.Icon, { name: iconLeft, size: size === "compact" ? "20px" : "24px" })),
      React__default.default.createElement(reactAriaComponents.Input, { className: `${styles.input} ${iconLeft === null ? styles.inputNoLeftIcon : ""}`, "data-zds": true, "data-size": size, placeholder, ref }),
      React__default.default.createElement(Typeahead_TypeaheadRightSlot.TypeaheadRightSlot, { iconRight, isTypeaheadDisabled: isDisabled, size })
    ),
    isInvalid && errorMessage ? React__default.default.createElement(ErrorMessage_ErrorMessage.ErrorMessage, { isCompact: size === "compact" }, errorMessage) : helpText && React__default.default.createElement(Description_Description.Description, { isCompact: size === "compact" }, helpText),
    React__default.default.createElement(
      reactAriaComponents.Popover,
      { className: `${styles.popover} ${menuWidth ? styles.customWidth : ""} ${classNamePopOver !== null && classNamePopOver !== void 0 ? classNamePopOver : ""}`, "data-zds": true, offset: 5, style: menuWidth ? { "--menu-width": menuWidth } : void 0 },
      React__default.default.createElement(reactAriaComponents.ListBox, { className: styles.listBox, "data-zds": true }, typeof children === "function" ? (item) => children(item) : children)
    )
  );
});
const Typeahead = Object.assign(TypeaheadRoot, {
  Item: Typeahead_TypeaheadItem.TypeaheadItem
});

exports.Typeahead = Typeahead;
exports.TypeaheadRoot = TypeaheadRoot;
//# sourceMappingURL=Typeahead.cjs.js.map
